
import { config } from "@backstagex/core/src/config";

const fields = [
  {
    type: 'bsx-label',
    label: '報名課程',
    model: 'course_name',
    fieldClasses: 'bold',
  },
  {
    type: 'bsx-label',
    label: '預約大名',
    model: 'name',
    fieldClasses: 'bold',
  },
  {
    type: 'bsx-label',
    label: 'Email',
    model: 'email',
    fieldClasses: 'bold',
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '身分證號',
    model: 'identity',
    placeholder: '身分證號',
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '手機號碼',
    model: 'mobile',
    placeholder: '手機號碼',
  },
  {
    type: 'bsx-label',
    label: '報名狀況',
    model: 'booking_status_label',
    fieldClasses: 'bold',
  },
  {
    type: 'bsx-label',
    label: '報到狀況',
    model: 'checkin_status_label',
    fieldClasses: 'bold',
  },
  {
    type: 'bsx-label',
    label: '後台取消管理員',
    model: 'cancel_admin_name',
    fieldClasses: 'bold',
    visible: (model) => model && model.booking_status == 'BSX_CANCEL',
  },
  {
    type: 'bsx-label',
    label: '報名時間',
    model: 'booking_time',
    fieldClasses: 'bold',
  },
  {
    type: "x-buttonCancelCourseBookingField",
    visible: (model) => model && model.booking_status == 'SIGN_UP',
  },
  {
    type: 'bsx-label',
    label: '取消預約時間',
    model: 'cancel_booking_time',
    fieldClasses: 'bold',
  },
  {
    type: 'bsx-toggle',
    label: '是否已報到',
    model: 'checkin_status',
    required: true,
  },
  {
    type: "bsx-dateTimePicker",
    label: "報到時間",
    model: "checkin_time",
    placeholder: "請選擇日期",
    hideClockIcon: true,
  },
  {
    type: 'bsx-toggle',
    label: '是否需處理',
    model: 'handle_status',
    required: true,
  },
  {
    type: "bsx-dateTimePicker",
    label: "處理時間",
    model: "checkin_time",
    placeholder: "請選擇日期",
    hideClockIcon: true,
  }
];

export default fields;
